import { endpoint } from 'modules/debate/constants'

import { ApolloClient, createNetworkInterface } from 'react-apollo'

const networkInterface = createNetworkInterface({
  uri: `${endpoint}/graphql`,
  opts: {
    headers: {
      Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}` // eslint-disable-line no-process-env
    }
  }
})

export default new ApolloClient({
  networkInterface
})



// WEBPACK FOOTER //
// ./client/base/apolloClient.js